import React, { useState } from "react";
import {
    Drawer,
    Box,
    Typography,
    TextField,
    MenuItem,
    Button,
    IconButton,
    FormHelperText
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { mainSearchMenuItems, adminSearchMenuItems } from "../constants/menuItems";

const SearchDrawer = ({ open, onClose, onSearch, userRoleName }) => {
    const [category, setCategory] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const combinedSearchItems = [...mainSearchMenuItems];
    if (userRoleName === "admin") {
        combinedSearchItems.push(...adminSearchMenuItems);
    };

    const handleSearch = () => {
        if (!category || !searchTerm.trim()) return;
        onSearch(category, searchTerm);
        setCategory("");
        setSearchTerm("")
        setTimeout(() => {
            document.activeElement.blur();
        }, 100);
    };

    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ width: 300, p: 3 }}>
                {/* Close Button */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="h6">Search</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Category Selection */}
                <TextField
                    fullWidth
                    select
                    label="Select Category"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    variant="outlined"
                    sx={{ mt: 2 }}
                >
                    {combinedSearchItems.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                            {item.label}
                        </MenuItem>
                    ))}
                </TextField>

                {/* Search Input */}
                <TextField
                    fullWidth
                    label="Enter search term"
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyUp={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            handleSearch();
                        }
                    }}
                    disabled={!category}
                />

                {/* Helper Text: Show message if category is not selected */}
                {!category && (
                    <FormHelperText sx={{ color: "red", mt: 1 }}>
                        Please select a category first
                    </FormHelperText>
                )}

                {/* Search Button */}
                <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 2 }}
                    onClick={handleSearch}
                    disabled={!category || !searchTerm.trim()}
                >
                    Search
                </Button>
            </Box>
        </Drawer>
    );
};

export default SearchDrawer;